import { Box, Paper, Skeleton, Stack, Typography } from '@mui/material';

import { MarketWidgetSkeleton } from '@/pages/Markets/MarketsSkeleton/MarketWidgetSkeleton';

const MarketsSkeleton = () => (
  <Box data-testid='markets-skeleton'>
    <Typography sx={{ my: 5 }}>Loading your data, please wait...</Typography>
    <Paper sx={{ py: 2, px: 3, width: '100%', height: 56 }}>
      <Skeleton width='25%' />
    </Paper>
    <Stack
      useFlexGap
      direction='row'
      flexWrap='wrap'
      spacing={3}
      sx={{ width: '100%', mt: 3 }}
    >
      {[0, 1, 2, 3, 4, 5].map(paper => (
        <MarketWidgetSkeleton key={paper} />
      ))}
    </Stack>
  </Box>
);

export default MarketsSkeleton;
